/**
 * Detects whether a user message in the floating widget represents
 * a complex coaching query that would benefit from the full Coach page.
 *
 * Complex intents include: plan generation, multi-week requests,
 * injury questions, detailed feedback requests, and program design.
 */

const PLAN_PATTERNS = [
  /\b(plan|program|schedule|periodis[ez]|block)\b/i,
  /\b(build|create|generate|design)\s+(me\s+)?(a\s+)?(training|workout|season|race|week)/i,
  /\bmulti[- ]?week\b/i,
  /\b(next|this|my)\s+(week|month|season|cycle|block)\b/i,
  /\btrain(ing)?\s+for\b/i,
];

const INJURY_PATTERNS = [
  /\b(injur(y|ed|ies))\b/i,
  /\b(pain|painful)\b/i,
  /\b(hurt|hurts|hurting)\b/i,
  /\b(ache|aching)\b/i,
  /\b(strain|strained)\b/i,
  /\b(sore|soreness)\b/i,
  /\b(swollen|swelling)\b/i,
];

const FEEDBACK_PATTERNS = [
  /\b(feedback|review|analy[sz]e|assess|evaluate)\s+(my|this|the|last|today)/i,
  /\bhow\s+did\s+(i|my)\b/i,
  /\bwhat\s+went\s+(wrong|right|well)\b/i,
];

const COMPLEX_TOPIC_PATTERNS = [
  /\b(periodis[ez]ation|macrocycle|mesocycle|microcycle)\b/i,
  /\b(race\s+strategy|taper|peak)\b/i,
  /\b(nutrition|fueling|hydration)\s+(plan|strategy)\b/i,
];

/**
 * Returns true if the message likely represents a complex coaching query
 * that would benefit from the full Coach page experience.
 */
export function detectComplexIntent(message: string): boolean {
  if (!message || message.trim().length < 3) return false;

  const allPatterns = [
    ...PLAN_PATTERNS,
    ...INJURY_PATTERNS,
    ...FEEDBACK_PATTERNS,
    ...COMPLEX_TOPIC_PATTERNS,
  ];

  return allPatterns.some((pattern) => pattern.test(message));
}
